import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AppConstants } from '../../../config/app-constants';
import { OSHA_ENDPOINTS } from '../../../endpoints.const';
import { LoaderService } from '../../core/services/loading.service';

@Injectable({
    providedIn: 'root'
})
export class OshaService {
    private apiUrl = AppConstants.APP_BASE_API_URL;

    private yearsSubject = new BehaviorSubject<string[]>([]);
    private establishmentYears = new BehaviorSubject<string[]>([]);
    private statesSubject = new BehaviorSubject<any[]>([]);
    private illnessTypesSubject = new BehaviorSubject<any[]>([]);
    private sevResultsSubject = new BehaviorSubject<any[]>([]);
    private caseSeriousResValue = new BehaviorSubject<string>('');
    private empName = new BehaviorSubject<string>('');
    private injryDate = new BehaviorSubject<string>('');
    private deathDate = new BehaviorSubject<string>('');
    private injryDes = new BehaviorSubject<string>('');
    private oshaClaimID = new BehaviorSubject<string>('');
    private nonRecorable = new BehaviorSubject<boolean>(false);

    years$ = this.yearsSubject.asObservable();
    establishmentYears$ = this.establishmentYears.asObservable();
    states$ = this.statesSubject.asObservable();
    illnessTypes$ = this.illnessTypesSubject.asObservable();
    sevResults$ = this.sevResultsSubject.asObservable();
    caseSeriousResValue$ = this.caseSeriousResValue.asObservable();
    empName$ = this.empName.asObservable();
    injryDate$ = this.injryDate.asObservable();
    deathDate$ = this.deathDate.asObservable();
    injryDes$ = this.injryDes.asObservable();
    oshaClaimID$ = this.oshaClaimID.asObservable();
    nonRecorable$ = this.nonRecorable.asObservable();

    setoshaClaimIDValue(value:string){
        this.oshaClaimID.next(value)
    }
    setinjryDesValue(value:string){
        this.injryDes.next(value)
    }
    setinjryDateValue(value){
        this.injryDate.next(value)
    }
    setempNameValue(value:string){
        this.empName.next(value)
    }
    setdeathDateValue(value){
        this.deathDate.next(value);
    }
    setcaseSeriousResValue(value: string) {
        this.caseSeriousResValue.next(value);
    }
    setnonRecorableValue(val){
        this.nonRecorable.next(val)
    }
    constructor(public http: HttpClient, public loaderService: LoaderService) { }

    fetchData(payload) {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        let url = `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.CASE_SEARCH}`;
        return this.http.post(url, payload);
    }
    downloadData(payload) {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        let url = `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.DOWNLOAD_ESTABLISHMENT_FILE}`;
        return this.http.post(url, payload, { observe: 'response', responseType: 'arraybuffer'});
    }

    //Will be changed later
    uploadFile(file: File): Observable<HttpEvent<any>> {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        const formData: FormData = new FormData();
        formData.append('file', file); // 'file' is the field name expected by the API

        const req = new HttpRequest(
            'POST',
            `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.UPLOAD_ESTABLISHMENT_FILE}?orgnztnId=${+this.loaderService.getItem('orgId')}`,
            formData,
            {
                reportProgress: true,
                responseType: 'json',
                headers: headers
            }
        );

        return this.http.request(req);
    }

    //Will be changed later
    downloadErrorReport(file: File): Observable<HttpEvent<any>> {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        const formData: FormData = new FormData();
        formData.append('file', file); // 'file' is the field name expected by the API

        return this.http.post(
            `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.DOWNLOAD_ERROR_REPORT}?orgnztnId=${+this.loaderService.getItem('orgId')}&uploadType=''`,
            formData,
            {
                headers,
                responseType: 'blob',
                observe: 'response'
            }
        );
    }

    fetchDropdownData() {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        const payload = {
            actionType: 'CASE_MANAGEMENT',
            operation: 'OSHA_METADATA',
            organizationId: this.loaderService.getItem('orgId')
        };
        let url = `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.DROPDOWN}`;

        return this.http.post(url, payload).pipe(
            tap((data: any) => {
                this.yearsSubject.next(data.years ?? []);
                this.establishmentYears.next(data.establishmentYears ?? []);
                this.statesSubject.next(data.states ?? []);
                this.illnessTypesSubject.next(data.illnessTypes ?? []);
                this.sevResultsSubject.next(data.sevResults ?? []);
            })
        );
    }

    modifyColumnSaveBtn(payload: any): Observable<any> {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        let url = `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.CASE_SEARCH}`;
        return this.http.post<any>(url, payload);
    }

    getModifyDropdownData(payload: any): Observable<any> {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        let url = `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.CASE_SEARCH}`;
        return this.http.post<any>(url, payload);
    }

    refineResults(payload: any): Observable<any> {
        const header = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });

        let url = `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.CASE_SEARCH}`;
        return this.http.post<any>(url, payload);
    }

    downloadInjuryReport(payload: any): Observable<any> {
        const header = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        })

        let url = `${AppConstants.APP_BASE_API_URL}${OSHA_ENDPOINTS.INJURY_REPORT}`;
        return this.http.post(url, payload, { observe: 'response', responseType: 'arraybuffer' });
    }

    restFormData(){
        this.empName.next('');
        this.injryDate.next('');
        this.deathDate.next('');
        this.injryDes.next('');
        this.oshaClaimID.next('');
        this.caseSeriousResValue.next('')
        this.nonRecorable.next(false)
    }
}
